import {Component, Input} from '@angular/core';
import {ProgressBarDataComponent} from '../../../../shared/components/progress-bar-data/progress-bar-data.component';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';

@Component({
  selector: 'app-card-sessao-linha-central',
  standalone: true,
  imports: [
    ProgressBarDataComponent
  ],
  templateUrl: './card-sessao-linha-central.component.html',
  styleUrl: './card-sessao-linha-central.component.css'
})
export class CardSessaoLinhaCentralComponent {

  @Input() sessao?: Sessao;


}
